// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__Hs56V","slider":"Switch_slider__Q9bWT","disabled":"Switch_disabled__gm36K","checked":"Switch_checked__yx66n"};